import { DropdownMenuRadioItem } from '@/components/ui/dropdown-menu';
import { useLocale } from '@/lib/contexts/locale-context';
import { LocaleFlag } from '@/components/ui/app/icons/locale-flags';

/**
 * Lignes du sélecteur de langue : drapeau rond + nom de la langue, la langue
 * active étant signalée par un fond.
 *
 * À placer dans un <DropdownMenuRadioGroup value={locale} onValueChange={setLocale}>.
 * Partagé par les deux sélecteurs (sous-menu ⚙️ d'AppLayout, icône 🌐 de
 * PublicLayout), qui rendaient jusqu'ici la même liste chacun de leur côté.
 *
 * `data-[state=checked]:focus:` en plus de `data-[state=checked]:` : la classe de
 * base du primitif pose `focus:bg-surface`, de même spécificité que
 * `data-[state=checked]:bg-…`. Survoler la ligne active aurait donc rendu un
 * gagnant dépendant de l'ordre des règles dans la feuille générée. Le variant à
 * deux conditions est plus spécifique et tranche de façon déterministe.
 */
export function LocaleMenuItems() {
    const { availableLocales, localeNames } = useLocale();

    return availableLocales.map((code) => (
        <DropdownMenuRadioItem
            key={code}
            value={code}
            hideIndicator
            className="cursor-pointer gap-2 data-[state=checked]:bg-surface-active data-[state=checked]:font-medium data-[state=checked]:focus:bg-surface-active"
        >
            <LocaleFlag code={code} />
            {localeNames[code]}
        </DropdownMenuRadioItem>
    ));
}
